// extracted by mini-css-extract-plugin
export var button = "footer-download-module--button--f086e";
export var cover = "footer-download-module--cover--299c7";
export var section = "footer-download-module--section--5db8c";
export var text = "footer-download-module--text--27db9";
export var title = "footer-download-module--title--83a59";
export var video = "footer-download-module--video--398e9";
export var wrapperPlayer = "footer-download-module--wrapperPlayer--fb13f";
export var wrapperText = "footer-download-module--wrapperText--a4a32";